import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d089198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CategoryAM" }
const _hoisted_2 = { class: "CategoryAM-title" }
const _hoisted_3 = { class: "CategoryAM-list" }
const _hoisted_4 = { class: "CategoryAM-list-column-name tstn" }

import { t } from '@/plugins/i18n'
import { c1688 } from '@/assets/js/platform/category'
import CategoryGroupPop from './CategoryGroupPop.vue'

import { Site } from '@/common/const'
import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const stationCode = useSite2Station()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(_unref(c1688).title)), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(c1688).row, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "CategoryAM-list-row tstn",
          key: rowIndex
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.column, (column, columnIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "CategoryAM-list-column",
              key: columnIndex
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(stationCode)=== _unref(Site).JA ? column.first_name_ja : _unref(t)(column.first_name)), 1)
            ]))
          }), 128)),
          _createVNode(CategoryGroupPop, {
            class: "CategoryAM-list-pop",
            groupData: row.column
          }, null, 8, ["groupData"])
        ]))
      }), 128))
    ])
  ]))
}
}

})